export default "__VITE_ASSET__Ca1Da26j__"